export default {
  systemName: '统一登录平台',
  title: {
    login: '登录',
    account: '账号/邮箱',
    phone: '手机号',
    smsCode: '验证码',
    password: '密码',
  },
  msg: {
    account: '请输入账号',
    password: '请输入密码',
    passwordRequired: '请输入密码',
    phoneRequired: '请输入手机号',
    phoneInvalid: '请输入正确的手机号',
    phoneLengthInvalid: '手机号长度应为5-15位',
    smsCodeRequired: '请输入验证码',
    smsCodeInvalid: '请输入6位数字验证码',
    sendCodeFailed: '验证码发送失败，请重试',
    sendCodeSuccess: '验证码已发送',
    loginFailed: '登录失败，请重试',
  },
  btn: {
    login: '登录',
    sendCode: '获取验证码',
    resend: '后再获取',
  },
};
